module.exports = __webpack_public_path__ + "img/gt.c9385b06.svg";